import { Input, InputProps, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";

import { getErrorMessage } from "../utils/errors";
import { showErrorToast } from "@src/appV2/lib/Notifications";

interface EditProps extends InputProps {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventFn: (value: any) => Promise<any>;
  defaultValue: string | undefined;
  /**
   * While it is unclear what addOnBefore really means, this
   * code uses it as a partial label.
   */
  addonBefore: string;
}

export function Edit(props: EditProps) {
  const { eventFn, defaultValue, addonBefore, ...rest } = props;
  const [isLoading, setLoading] = useState(false);
  const [value, setValue] = useState(defaultValue);
  const [preValue, setPreValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
    setPreValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (e) => {
    setValue(e.currentTarget.value);
  };

  const onConfirm = async () => {
    try {
      await eventFn(value);
      setPreValue(value);
    } catch (error) {
      showErrorToast(getErrorMessage(error));
      setValue(preValue);
    } finally {
      setLoading(false);
    }
  };

  const onCancel = () => {
    setValue(preValue);
    setLoading(false);
  };

  const handleEvent = () => {
    setLoading(true);
    if (value !== preValue && !isLoading) {
      Modal.confirm({
        title: `Are you sure, you want to change '${addonBefore}'?`,
        onOk: onConfirm,
        onCancel,
        okText: "Yes",
      });
    } else {
      setLoading(false);
    }
  };

  const suffix = isLoading ? <Spin size="small" style={{ color: "rgba(0,0,0,.45)" }} /> : <span />;

  return (
    <Input
      style={{ width: "55%" }}
      addonBefore={addonBefore}
      suffix={suffix}
      onBlur={handleEvent}
      value={value ?? ""}
      onPressEnter={handleEvent}
      onChange={handleChange}
      disabled={isLoading}
      {...rest}
    />
  );
}
